export const miniCartHotJar = () => {
  if (window.hj === 'function') {
    window.hj('trigger', 'mini_cart_open')
  }
}
